import { LowerCasePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CreditCard } from '@df/session/api/credit-cards/credit-card';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { PaymentIconComponent } from '../../../common/payment-icon/payment-icon.component';

@Component({
    selector: 'account-saved-card-body',
    templateUrl: './account-saved-card-body.html',
    standalone: true,
    imports: [PaymentIconComponent, NgClass, LowerCasePipe, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountSavedCardBodyComponent {
    @Input()
    card?: CreditCard;
}
